import React from "react";

import Banner from "../components/Markets/Banner";
import TradeAssets from "../components/Markets/TradeAssets";
import WhyTrade from "../components/Markets/WhyTrade";
import HowCFD from "../components/Markets/HowCFD";
import Assistance from "../components/Home/Assistance";

function Markets() {
  return (
    <main className="bg-white overflow-hidden">
      <Banner />
      <TradeAssets />
      <WhyTrade />
      <HowCFD />
      <div className="mt-[80px] xl:mt-[160px]">
        <Assistance />
      </div>
    </main>
  );
}

export default Markets;
